import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/utils';

type ButtonProps = {
  className?: string;
  children: React.ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonSimple = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }: ButtonProps, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'flex-inline items-center justify-center rounded-lg p-2 hover:bg-brand dark:bg-brand-dark-20 dark:text-brand-light-25 dark:hover:bg-brand-dark dark:hover:text-brand-dark-75',
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );
  },
);
export default ButtonSimple;
